import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";

const ConfirmationDialog = (props) => {
    const okButtonHandler = () => {        
        props.onOk();
        props.onClose();
    }
    return <Dialog
    open={props.open}
    onClose={props.onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{props.caption}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {props.text}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={okButtonHandler} color="secondary" autoFocus>
        Ok
      </Button>
    </DialogActions>
  </Dialog>
}

export default ConfirmationDialog;